import { FaceLandmarker, FilesetResolver, DrawingUtils } from "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14";

/* ==========================================================
   FACE-SHAPE → FRAME-STYLE MAP
   ========================================================== */
const FRAME_STYLES = {
  "panto":            { name: "Round / Panto",     url: "https://www.shop-srgopalrao.co/collections/panto?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&sort_by=best-selling", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/panto/products.json?limit=250" },
  "cat-eye":          { name: "Cat Eye",            url: "https://www.shop-srgopalrao.co/collections/cat-eye?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&sort_by=created-descending", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/cat-eye/products.json?limit=250" },
  "rectangle":        { name: "Rectangle",          url: "https://www.shop-srgopalrao.co/collections/rectangle?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&sort_by=best-selling", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/rectangle/products.json?limit=250" },
  "square-frame":     { name: "Square",             url: "https://www.shop-srgopalrao.co/collections/square?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&sort_by=manual", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/square/products.json?limit=250" },
  "aviator":          { name: "Aviator",            url: "https://www.shop-srgopalrao.co/collections/brands?filter.p.tag=Aviator&filter.v.availability=1&sort_by=created-descending", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/brands/products.json?limit=250", tag: "Aviator" },
  "wayfarer":         { name: "Wayfarer",           url: "https://www.shop-srgopalrao.co/collections/brands?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=Wayfarer&sort_by=created-descending", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/brands/products.json?limit=250", tag: "Wayfarer" },
  "geometric":        { name: "Geometric",          url: "https://www.shop-srgopalrao.co/collections/brands?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=Geometric&sort_by=created-descending", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/brands/products.json?limit=250", tag: "Geometric" },
  "browline":         { name: "Browline",           url: "https://www.shop-srgopalrao.co/collections/brands?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=Browline&sort_by=created-descending", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/brands/products.json?limit=250", tag: "Browline" },
  "butterfly":        { name: "Butterfly",          url: "https://www.shop-srgopalrao.co/collections/brands?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=Butterfly&sort_by=created-descending", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/brands/products.json?limit=250", tag: "Butterfly" },
  "oval-frame":       { name: "Oval",               url: "https://www.shop-srgopalrao.co/collections/brands?filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=Oval&sort_by=created-descending", productsJsonUrl: "https://www.shop-srgopalrao.co/collections/brands/products.json?limit=250", tag: "Oval" }
};

/* Rebuilt directly from SRGR's official Style Guide checkmark table
   (Face Shapes × Frame Styles). Order within each shape's list is chosen
   so the top 3 (the medal picks) differ across shapes wherever the table
   allows — Round and Triangular only have 4 eligible styles each in the
   source table, so some overlap there is unavoidable, not an oversight. */
const FACE_SHAPES = {
  "Oval": {
    tagline: "You have a naturally balanced face shape, which means you can wear a wide variety of frame styles.",
    frames: ["cat-eye","butterfly","wayfarer","square-frame","rectangle","geometric","panto","browline","oval-frame","aviator"]
  },
  "Round": {
    tagline: "Soft curves, equal width and length — angular frames add definition.",
    frames: ["rectangle","geometric","browline","cat-eye","wayfarer","square-frame"]
  },
  "Square": {
    tagline: "Strong jawline, wide forehead — softer, rounded frames balance your features.",
    frames: ["panto","oval-frame","butterfly","cat-eye","aviator"]
  },
  "Triangular": {
    tagline: "Wider forehead, narrower jawline — frames that balance the width up top work best.",
    frames: ["rectangle","square-frame","geometric","panto","oval-frame"]
  },
  "Heart": {
    tagline: "Wider cheekbones, narrower jaw — frames that soften the brow line suit you well.",
    frames: ["panto","butterfly","cat-eye","rectangle","square-frame","geometric","oval-frame"]
  }
};

const CATEGORY_PRODUCT_TYPE = { optical: 'OPTICAL', sunglasses: 'SUNGLASSES' };
const CATEGORY_LABEL = { optical: 'Optical Frames', sunglasses: 'Sunglasses' };
function productCategory(p){
  return ((p && p.product_type) || '').toLowerCase().includes('sunglass') ? 'sunglasses' : 'optical';
}
function buildGenderUrl(styleKey, genderLabel, category){
  const style = FRAME_STYLES[styleKey];
  if(!style) return "https://www.shop-srgopalrao.co/collections/brands";
  const cat = category || window.fitProfile.category;
  let url = style.url;
  if(genderLabel && genderLabel !== "Unisex"){
    url += (url.includes("?") ? "&" : "?") + "filter.p.tag=" + encodeURIComponent(genderLabel);
  }
  if(cat && CATEGORY_PRODUCT_TYPE[cat]){
    url += (url.includes("?") ? "&" : "?") + "filter.p.product_type=" + CATEGORY_PRODUCT_TYPE[cat];
  }
  return url;
}

const arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const MEDALS = ['🥇','🥈','🥉'];

/* TODO (Nid): drop in SRGR's WhatsApp Business number here, digits only
   with country code, e.g. "9198XXXXXXX" — used for the "Chat on WhatsApp"
   button in the eye-size popup. */
const WHATSAPP_NUMBER = "912071279291";
const WHATSAPP_MESSAGE = "Hello team, I'd like with finding my eye size.";

/* ==========================================================
   REAL PER-PRODUCT EYE SIZE DATA
   ========================================================== */
let sizeMap = {};
const sizeMapLoading = (async () => {
  try{
    const res = await fetch(window.SIZE_MAP_URL);
    if(!res.ok) throw new Error('bad response ' + res.status);
    sizeMap = await res.json();
  }catch(err){
    console.warn('Could not load eye-size data — product matching will show general links instead.', err);
  }
})();

function frameShapeLabelFor(styleKey){
  const name = (FRAME_STYLES[styleKey] || {}).name || 'Other Styles';
  const known = ["Square","Rectangle","Wayfarer","Round / Panto","Oval","Cat Eye","Aviator","Modified Aviator","Browline","Geometric","Butterfly"];
  return known.includes(name) ? name : "Other Styles";
}

function bucketForProduct(product, shapeLabel){
  const entry = sizeMap[product.handle];
  if(entry == null) return null;
  const mm = typeof entry === 'object' ? entry.mm : entry;
  const bridge = typeof entry === 'object' ? entry.bridge : null;
  const category = (product.product_type || '').toLowerCase().includes('sunglass') ? 'sunglasses' : 'optical';

  // The merchant's own "Suggested Size" (pulled straight from each
  // product's description) is the authoritative source whenever it
  // exists — it already accounts for bridge width, brand-specific
  // fit, and anything else that a generic mm chart can't capture.
  // Only fall back to computing from raw eye-size mm when a product
  // has no merchant-stated size at all.
  if(typeof entry === 'object' && entry.suggested){
    return { size: entry.suggested, mm: mm || null, category };
  }

  if(mm == null) return null;
  const bounds = (window.SIZE_CHART[category] && window.SIZE_CHART[category][shapeLabel]) || window.SIZE_CHART[category]['Other Styles'];
  let size = mm <= bounds[0] ? 'Small' : (mm <= bounds[1] ? 'Medium' : 'Large');
  if(size === 'Small' && bridge != null && bridge >= LARGE_BRIDGE_THRESHOLD_MM){
    size = 'Medium';
  }
  return { size, mm, category };
}

async function fetchMatchingProducts(styleKey, genderLabel, targetSize, maxResults=6, category){
  const style = FRAME_STYLES[styleKey];
  if(!style || !style.productsJsonUrl) return [];
  try{
    const res = await fetch(style.productsJsonUrl);
    if(!res.ok) throw new Error('bad response ' + res.status);
    const data = await res.json();
    let products = data.products || [];
    products = products.filter(p => (p.variants || []).some(v => v.available));
    const wantCat = category || window.fitProfile.category;
    if(wantCat) products = products.filter(p => productCategory(p) === wantCat);

    if(style.tag){
      products = products.filter(p => (p.tags||[]).some(t => t.toLowerCase() === style.tag.toLowerCase()));
    }
    if(genderLabel && genderLabel !== 'Unisex'){
      products = products.filter(p =>
        (p.tags||[]).some(t => t.toLowerCase() === genderLabel.toLowerCase()) ||
        (p.tags||[]).some(t => t.toLowerCase() === 'unisex')
      );
    }

    const shapeLabel = frameShapeLabelFor(styleKey);
    const matches = [];
    for(const p of products){
      const bucket = bucketForProduct(p, shapeLabel);
      if(bucket && bucket.size === targetSize){
        matches.push({
          title: p.title,
          handle: p.handle,
          image: p.images && p.images[0] ? p.images[0].src : null,
          url: `https://www.shop-srgopalrao.co/products/${p.handle}`,
          eyeSize: bucket.mm
        });
        if(matches.length >= maxResults) break;
      }
    }
    return matches;
  }catch(err){
    console.warn('Could not load matching products for', styleKey, err);
    return [];
  }
}

/* ---------- Shared Fit Profile state ---------- */
window.fitProfile = window.fitProfile || { faceShape: null, gender: null, styles: [], size: null, sizeCategory: null, sizeShape: null };
if(!window.fitProfile.category) window.fitProfile.category = 'optical';   /* 'optical' | 'sunglasses': drives every list and link below */

function updateFitProfilePanel(){
  const fp = window.fitProfile;
  const fpFaceShape = document.getElementById('fpFaceShape');
  const fpStyles = document.getElementById('fpStyles');
  const fpSize = document.getElementById('fpSize');
  const fpCta = document.getElementById('fpCta');

  if(fp.faceShape){
    fpFaceShape.textContent = fp.faceShape + ' ✓';
    fpFaceShape.className = 'fp-value done';
  }
  if(fp.styles && fp.styles.length){
    const names = fp.styles.slice(0,4).map(k => FRAME_STYLES[k] ? FRAME_STYLES[k].name : k);
    fpStyles.textContent = names.join(' · ');
    fpStyles.className = 'fp-value done';
  }
  if(fp.size){
    fpSize.textContent = fp.size + ' ✓';
    fpSize.className = 'fp-value done';
  }

  const fitProfileEl = document.getElementById('fitProfile');
  if(fp.faceShape || (fp.styles && fp.styles.length) || fp.size){
    fitProfileEl.classList.remove('collapsed');
  }

  if(fp.faceShape && fp.styles && fp.styles.length && fp.size){
    fpCta.style.display = 'inline-flex';
  }

  updateJourneyStatus();
  updateShopYourFit();
}

function updateJourneyStatus(){
  const fp = window.fitProfile;
  const setState = (n, state, label) => {
    const el = document.querySelector('.jstep[data-jstep="'+n+'"]');
    const status = document.getElementById('jstatus'+n);
    if(!el) return;
    el.classList.remove('locked','active','complete');
    el.classList.add(state);
    if(status && n !== 1) status.textContent = label;
  };

  setState(1, fp.faceShape ? 'complete' : 'active', fp.faceShape ? 'Done' : 'Take Photo Below');
  setState(2, (fp.gender && fp.styles.length) ? 'complete' : (fp.faceShape ? 'active' : 'locked'), (fp.gender && fp.styles.length) ? 'Done' : (fp.faceShape ? 'Ready' : 'Locked'));
  setState(3, (fp.gender && fp.styles.length) ? 'active' : 'locked', (fp.gender && fp.styles.length) ? 'Ready' : 'Locked');

  const jstatus1 = document.getElementById('jstatus1');
  if(jstatus1) jstatus1.textContent = fp.faceShape ? 'Done — Retake?' : 'Take Photo Below';
}

const fpToggle = document.getElementById('fpToggle');
fpToggle.addEventListener('click', () => document.getElementById('fitProfile').classList.toggle('collapsed'));

/* ---------- Upload + preview ---------- */
const dropzone   = document.getElementById('dropzone');
const fileInput  = document.getElementById('fileInput');
const cameraInput = document.getElementById('cameraInput');
const cameraBtn  = document.getElementById('cameraBtn');
const cameraAlt  = document.querySelector('.camera-alt');
const cameraWrap = document.getElementById('cameraWrap');
const cameraVideo = document.getElementById('cameraVideo');
const cameraCanvas = document.getElementById('cameraCanvas');
const cameraError = document.getElementById('cameraError');
const cameraStatus = document.getElementById('cameraStatus');
const cameraGuideOval = document.getElementById('cameraGuideOval');
const cameraCountdown = document.getElementById('cameraCountdown');
const cameraCancelBtn = document.getElementById('cameraCancelBtn');
const cameraCaptureBtn = document.getElementById('cameraCaptureBtn');
const previewWrap= document.getElementById('previewWrap');
const previewCanvas = document.getElementById('previewCanvas');
const previewCtx = previewCanvas.getContext('2d');
const drawingUtils = new DrawingUtils(previewCtx);
const mapHint    = document.getElementById('mapHint');
const actionsRow = document.getElementById('actionsRow');
const analyzeBtn = document.getElementById('analyzeBtn');
const resetBtn   = document.getElementById('resetBtn');
const statusLine = document.getElementById('statusLine');
const scanLine   = document.getElementById('scanLine');
const resultsEl  = document.getElementById('results');

const PREVIEW_MAX_DIM = 480;
let sourceImage = null;
let lastLandmarks = null;
let cameraStream = null;

/* Camera only: photo uploads gave unreliable results, so the upload box now just opens the camera. */
(function cameraOnlySetup(){
  const st = document.createElement('style');
  st.textContent = `
    .camera-alt{display:none !important}
    #dropzone .fsi-cam-cta{display:flex;flex-direction:column;align-items:center;gap:10px;padding:6px 0;text-align:center}
    #dropzone .fsi-cam-cta svg{width:44px;height:44px;color:var(--gold-deep,#8f846d)}
    #dropzone .fsi-cam-cta strong{font-family:var(--serif,Georgia,serif);font-size:1.25rem;font-weight:500;color:var(--dark,#414042)}
    #dropzone .fsi-cam-cta span{font-size:.85rem;line-height:1.4;color:var(--sage,#7e827c);max-width:320px}
  `;
  document.head.appendChild(st);
  dropzone.innerHTML = '<div class="fsi-cam-cta"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/><circle cx="12" cy="13.5" r="3.5"/></svg><strong>Take a photo</strong><span>Look straight at the camera in good light, hair away from your face, neutral expression.</span></div>';
  dropzone.setAttribute('role', 'button');
  dropzone.setAttribute('tabindex', '0');
  dropzone.setAttribute('aria-label', 'Take a photo with your camera');
  dropzone.addEventListener('keydown', e => { if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openCamera(); } });
  if(typeof resetBtn !== 'undefined' && resetBtn) resetBtn.textContent = 'Retake photo';
})();
dropzone.addEventListener('click', () => openCamera());
['dragover','dragleave','drop'].forEach(evt => dropzone.addEventListener(evt, e => e.preventDefault()));

/* ---------- Live camera (works on desktop AND mobile) ---------- */
const supportsGetUserMedia = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
const cameraUploadFallback = document.getElementById('cameraUploadFallback');
const isTouchPhone = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '') || (window.matchMedia && window.matchMedia('(pointer:coarse)').matches && window.innerWidth < 900);

/* ---------- Auto-capture with a 3-2-1 countdown ---------- */
let autoCaptureInterval = null;
let autoCaptureBusy = false;
let autoCaptureAlignedCount = 0;
let countdownInterval = null;
let countdownActive = false;
const AUTO_CAPTURE_STABLE_FRAMES = 3;
const AUTO_CAPTURE_CHECK_MS = 400;
const COUNTDOWN_STEP_MS = 800;

function startAutoCaptureWatch(){
  stopAutoCaptureWatch();
  autoCaptureAlignedCount = 0;
  autoCaptureInterval = setInterval(async () => {
    if(autoCaptureBusy || countdownActive || !cameraStream || !cameraVideo.videoWidth) return;
    autoCaptureBusy = true;
    try{
      await loadLandmarker();
      const tmp = document.createElement('canvas');
      tmp.width = cameraVideo.videoWidth;
      tmp.height = cameraVideo.videoHeight;
      tmp.getContext('2d').drawImage(cameraVideo, 0, 0, tmp.width, tmp.height);
      const result = faceLandmarker.detect(tmp);

      if(!result.faceLandmarks || !result.faceLandmarks.length){
        autoCaptureAlignedCount = 0;
        if(cameraStatus) cameraStatus.textContent = 'Position your face inside the outline';
        if(cameraGuideOval) cameraGuideOval.classList.remove('aligned');
        return;
      }

      const lm = result.faceLandmarks[0];
      const cheekL = pointAt(lm, LM.cheekL, tmp.width, tmp.height);
      const cheekR = pointAt(lm, LM.cheekR, tmp.width, tmp.height);
      const top = pointAt(lm, LM.top, tmp.width, tmp.height);
      const chin = pointAt(lm, LM.chin, tmp.width, tmp.height);
      const centerXFrac = (cheekL.x + cheekR.x) / 2 / tmp.width;
      const centerYFrac = (top.y + chin.y) / 2 / tmp.height;
      const faceWidthFrac = distance(cheekL, cheekR) / tmp.width;

      const closeEnough =
        Math.abs(centerXFrac - 0.5) < 0.09 &&
        Math.abs(centerYFrac - 0.485) < 0.12 &&
        Math.abs(faceWidthFrac - 0.5) < 0.14;

      if(closeEnough){
        autoCaptureAlignedCount++;
        if(cameraGuideOval) cameraGuideOval.classList.add('aligned');
        if(cameraStatus) cameraStatus.textContent = autoCaptureAlignedCount >= AUTO_CAPTURE_STABLE_FRAMES ? 'Perfect — get ready…' : 'Hold still…';
        if(autoCaptureAlignedCount >= AUTO_CAPTURE_STABLE_FRAMES){
          beginCountdown();
        }
      } else {
        autoCaptureAlignedCount = 0;
        if(cameraGuideOval) cameraGuideOval.classList.remove('aligned');
        if(cameraStatus) cameraStatus.textContent = 'Position your face inside the outline';
      }
    }catch(err){
      console.warn('Auto-capture check failed:', err);
    }finally{
      autoCaptureBusy = false;
    }
  }, AUTO_CAPTURE_CHECK_MS);
}

function stopAutoCaptureWatch(){
  if(autoCaptureInterval){ clearInterval(autoCaptureInterval); autoCaptureInterval = null; }
  autoCaptureAlignedCount = 0;
  if(cameraGuideOval) cameraGuideOval.classList.remove('aligned');
}

function beginCountdown(){
  if(countdownActive) return;
  countdownActive = true;
  stopAutoCaptureWatch();
  if(cameraStatus) cameraStatus.textContent = '';
  let n = 3;
  if(cameraCountdown){
    cameraCountdown.textContent = n;
    cameraCountdown.style.display = 'flex';
  }
  countdownInterval = setInterval(() => {
    n--;
    if(n <= 0){
      clearInterval(countdownInterval);
      countdownInterval = null;
      if(cameraCountdown) cameraCountdown.style.display = 'none';
      countdownActive = false;
      capturePhotoFromVideo();
    } else if(cameraCountdown){
      cameraCountdown.textContent = n;
    }
  }, COUNTDOWN_STEP_MS);
}

function cancelCountdown(){
  if(countdownInterval){ clearInterval(countdownInterval); countdownInterval = null; }
  countdownActive = false;
  if(cameraCountdown) cameraCountdown.style.display = 'none';
}

async function openCamera(){
  if(!supportsGetUserMedia){
    if(isTouchPhone){ cameraInput.click(); }
    else{ setStatus('Your browser cannot open the camera. Please open this page on a phone or in Chrome or Safari.', true); }
    return;
  }
  dropzone.style.display = 'none';
  if(cameraAlt) cameraAlt.style.display = 'none';
  cameraWrap.style.display = 'block';
  cameraError.style.display = 'none';
  cameraUploadFallback.style.display = 'none';
  cameraCaptureBtn.style.display = 'inline-flex';
  if(cameraStatus) cameraStatus.textContent = 'Position your face inside the outline';
  try{
    cameraStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false });
    cameraVideo.srcObject = cameraStream;
    startAutoCaptureWatch();
  }catch(err){
    console.error(err);
    let msg = "We couldn't access your camera. Please check it is working and try again.";
    if(err && err.name === 'NotAllowedError') msg = "Camera access was blocked. Please allow the camera in your browser's site permissions and try again.";
    else if(err && err.name === 'NotFoundError') msg = "No camera was found on this device. Please open this page on a phone or a device with a camera.";
    else if(err && err.name === 'NotReadableError') msg = "Your camera is being used by another app right now. Close it and try again.";
    cameraError.textContent = msg;
    cameraError.style.display = 'block';
    cameraCaptureBtn.style.display = 'none';
    /* only phones get the "open phone camera" backup, so it can never turn into a gallery upload on a computer */
    if(isTouchPhone){ cameraUploadFallback.textContent = 'Open my phone camera instead'; cameraUploadFallback.style.display = 'block'; }
  }
}

if(cameraUploadFallback){
  cameraUploadFallback.addEventListener('click', () => {
    closeCamera();
    cameraInput.click();   /* the phone's own camera app (this input is set to capture a new photo) */
  });
}

function closeCamera(){
  stopAutoCaptureWatch();
  cancelCountdown();
  cameraWrap.style.display = 'none';
  dropzone.style.display = 'block';
  if(cameraAlt) cameraAlt.style.display = 'flex';
  if(cameraStream){
    cameraStream.getTracks().forEach(t => t.stop());
    cameraStream = null;
  }
}

function capturePhotoFromVideo(){
  if(!cameraVideo.videoWidth){
    cameraError.textContent = "The camera hasn't finished loading yet — give it a second and try again.";
    cameraError.style.display = 'block';
    return;
  }
  cameraCanvas.width = cameraVideo.videoWidth;
  cameraCanvas.height = cameraVideo.videoHeight;
  const ctx = cameraCanvas.getContext('2d');
  ctx.drawImage(cameraVideo, 0, 0, cameraCanvas.width, cameraCanvas.height);
  cameraCanvas.toBlob(blob => {
    closeCamera();
    handleFile(new File([blob], 'camera-photo.jpg', { type: 'image/jpeg' }));
  }, 'image/jpeg', 0.92);
}

cameraBtn.addEventListener('click', openCamera);
cameraCancelBtn.addEventListener('click', closeCamera);
cameraCaptureBtn.addEventListener('click', () => { cancelCountdown(); capturePhotoFromVideo(); });

cameraInput.addEventListener('change', e => {
  if(e.target.files && e.target.files[0]) handleFile(e.target.files[0]);
});

const jstatus1Link = document.getElementById('jstatus1');
if(jstatus1Link){
  jstatus1Link.addEventListener('click', () => { openCamera(); });
}

function handleFile(file){
  if(!file.type.startsWith('image/')){
    setStatus('Please take a photo with your camera.', true);
    return;
  }
  /* A phone-camera photo is brand new. An old gallery photo is turned away, because uploads gave unreliable results. */
  if(file.name !== 'camera-photo.jpg' && file.lastModified && (Date.now() - file.lastModified) > 3 * 60 * 1000){
    setStatus('Please take a new photo with your camera instead of choosing one from your gallery.', true);
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const img = new Image();
    img.onload = () => {
      sourceImage = img;
      lastLandmarks = null;
      drawBaseImage(img);
      previewWrap.style.display = 'block';
      dropzone.style.display = 'none';
      if(cameraAlt) cameraAlt.style.display = 'none';
      cameraWrap.style.display = 'none';
      actionsRow.style.display = 'flex';
      resultsEl.style.display = 'none';
      mapHint.style.display = 'none';
      setStatus('');
    };
    img.onerror = () => setStatus('Could not read that file — please try another photo.', true);
    img.src = reader.result;
  };
  reader.onerror = () => setStatus('Could not read that file — please try another photo.', true);
  reader.readAsDataURL(file);
}

function drawBaseImage(img){
  const scale = Math.min(PREVIEW_MAX_DIM / img.naturalWidth, PREVIEW_MAX_DIM / img.naturalHeight, 1);
  previewCanvas.width = Math.round(img.naturalWidth * scale);
  previewCanvas.height = Math.round(img.naturalHeight * scale);
  previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
  previewCtx.drawImage(img, 0, 0, previewCanvas.width, previewCanvas.height);
}

resetBtn.addEventListener('click', () => {
  sourceImage = null;
  lastLandmarks = null;
  fileInput.value = '';
  cameraInput.value = '';
  closeCamera();
  previewWrap.style.display = 'none';
  dropzone.style.display = 'block';
  if(cameraAlt) cameraAlt.style.display = 'flex';
  actionsRow.style.display = 'none';
  resultsEl.style.display = 'none';
  mapHint.style.display = 'none';
  setStatus('');
});

function setStatus(msg, isError=false){
  statusLine.textContent = msg;
  statusLine.classList.toggle('error', !!isError);
}

/* ---------- Analysis via in-browser face landmarks ---------- */
let faceLandmarker = null;
let landmarkerLoading = null;

function loadLandmarker(){
  if(landmarkerLoading) return landmarkerLoading;
  landmarkerLoading = (async () => {
    const filesetResolver = await FilesetResolver.forVisionTasks(
      "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm"
    );
    faceLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, {
      baseOptions: {
        modelAssetPath: "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task",
        delegate: "GPU"
      },
      runningMode: "IMAGE",
      numFaces: 1
    });
  })();
  return landmarkerLoading;
}
if('requestIdleCallback' in window) requestIdleCallback(loadLandmarker); else setTimeout(loadLandmarker, 1200);

function pointAt(landmarks, index, width, height){
  const p = landmarks[index];
  return { x: p.x * width, y: p.y * height };
}
function distance(a, b){ return Math.hypot(a.x - b.x, a.y - b.y); }

const LM = { foreheadL: 21, foreheadR: 251, cheekL: 234, cheekR: 454, jawL: 58, jawR: 288, top: 10, chin: 152, eyeOuterL: 33, eyeOuterR: 263, irisL: 468, irisR: 473 };

/* MediaPipe face-outline ring: used to read the face width at a chosen height. */
const FACE_OVAL = [10,338,297,332,284,251,389,356,454,323,361,288,397,365,379,378,400,377,152,148,176,149,150,136,172,58,132,93,234,127,162,21,54,103,67,109];

function silhouetteWidthAtY(landmarks, width, height, y){
  let minX = Infinity, maxX = -Infinity;
  for(let i = 0; i < FACE_OVAL.length; i++){
    const a = pointAt(landmarks, FACE_OVAL[i], width, height);
    const b = pointAt(landmarks, FACE_OVAL[(i + 1) % FACE_OVAL.length], width, height);
    if((a.y <= y && b.y > y) || (b.y <= y && a.y > y)){
      const x = a.x + (y - a.y) * (b.x - a.x) / (b.y - a.y);
      if(x < minX) minX = x;
      if(x > maxX) maxX = x;
    }
  }
  return (maxX > minX) ? (maxX - minX) : null;
}

/* PROVISIONAL thresholds, tune these after the trusted reference set is ready.
   lengthToCheek < roundMax            -> Round
   jaw + L5 both strong (any length)   -> Square
   otherwise                           -> ask one question (long faces: Oval / Heart / Triangular;
                                          shorter faces also get Square)
   "Not sure" fallback                 -> Heart if L5 is narrow, else Oval
   Tuned on 80 labelled takes: 39 answered directly (27 right), "Not sure" 23/41 right.  */
const FACE_RULES = {
  roundMax: 1.08,
  longMin: 1.14,
  squareJawMin: 0.905,
  squareL5Min: 0.92,
  l5Level: 0.65,
  heartL5Max: 0.90      /* "Not sure": L5 below this -> Heart, else Oval */
};

function explainShape(shape, answered){
  if(answered){
    return "Your face is a blend of the best of every shape. This is the one that shows most, and the frames below are picked to bring it out.";
  }
  const reasons = {
    Round:  "Your face length and width are close, with a soft, rounded jaw line.",
    Square: "A broad face with a strong, angular jaw line."
  };
  return reasons[shape] || '';
}

/* Debug capture: set fsLabel = 'name' in the console, analyse, then run copy(fsCSV()) */
window.__fsLog = window.__fsLog || [];
window.fsLabel = window.fsLabel || '';
window.fsCSV = function(){
  const cols = ['label','lengthToCheek','jawToCheek','foreheadToCheek','L5','route','result'];
  const rows = window.__fsLog.map(r => cols.map(c => {
    const v = r[c];
    if(v === undefined || v === null) return '';
    return typeof v === 'number' ? Math.round(v * 1000) / 1000 : v;
  }).join(','));
  return [cols.join(',')].concat(rows).join('\n');
};

/* Returns { shape, ask, fallback, measured }.
   shape  = a direct answer ('Round' | 'Square'), or null when a question is needed.
   ask    = null | 'long' | 'mid'                                                    */
function classifyFaceShape(landmarks, width, height){
  const forehead   = distance(pointAt(landmarks, LM.foreheadL, width, height), pointAt(landmarks, LM.foreheadR, width, height));
  const cheek      = distance(pointAt(landmarks, LM.cheekL, width, height),    pointAt(landmarks, LM.cheekR, width, height));
  const jaw        = distance(pointAt(landmarks, LM.jawL, width, height),      pointAt(landmarks, LM.jawR, width, height));
  const faceLength = distance(pointAt(landmarks, LM.top, width, height),       pointAt(landmarks, LM.chin, width, height));

  const topY  = pointAt(landmarks, LM.top, width, height).y;
  const chinY = pointAt(landmarks, LM.chin, width, height).y;
  const l5w   = silhouetteWidthAtY(landmarks, width, height, topY + FACE_RULES.l5Level * (chinY - topY));

  const measured = {
    lengthToCheek: faceLength / cheek,
    jawToCheek: jaw / cheek,
    foreheadToCheek: forehead / cheek,
    L5: (l5w === null) ? null : l5w / cheek
  };

  let shape = null, ask = null, fallback = 'Oval';
  if(measured.lengthToCheek < FACE_RULES.roundMax){
    shape = 'Round';
  }else if(measured.jawToCheek >= FACE_RULES.squareJawMin && measured.L5 !== null && measured.L5 >= FACE_RULES.squareL5Min){
    shape = 'Square';
  }else{
    ask = (measured.lengthToCheek > FACE_RULES.longMin) ? 'long' : 'mid';
    if(measured.L5 !== null && measured.L5 < FACE_RULES.heartL5Max) fallback = 'Heart';
  }

  const route = shape ? 'direct' : ('ask-' + ask);
  window.__fsLog.push({
    label: window.fsLabel,
    lengthToCheek: measured.lengthToCheek,
    jawToCheek: measured.jawToCheek,
    foreheadToCheek: measured.foreheadToCheek,
    L5: measured.L5,
    route: route,
    result: shape || '?'
  });
  console.log('[Face Shape Debug] measured=', measured, 'route=', route, '→', shape || '(ask)');

  return { shape, ask, fallback, measured };
}

function drawMeasurementOverlay(landmarks, width, height){
  const pts = {
    foreheadL: pointAt(landmarks, LM.foreheadL, width, height),
    foreheadR: pointAt(landmarks, LM.foreheadR, width, height),
    cheekL:    pointAt(landmarks, LM.cheekL, width, height),
    cheekR:    pointAt(landmarks, LM.cheekR, width, height),
    jawL:      pointAt(landmarks, LM.jawL, width, height),
    jawR:      pointAt(landmarks, LM.jawR, width, height),
    top:       pointAt(landmarks, LM.top, width, height),
    chin:      pointAt(landmarks, LM.chin, width, height)
  };

  const lines = [
    { a: pts.foreheadL, b: pts.foreheadR, label: 'Forehead',    side: 'above' },
    { a: pts.cheekL,    b: pts.cheekR,    label: 'Cheekbones',  side: 'above' },
    { a: pts.jawL,      b: pts.jawR,      label: 'Jaw',         side: 'below' },
    { a: pts.top,       b: pts.chin,      label: 'Face length', side: 'right' }
  ];

  previewCtx.save();
  previewCtx.lineWidth = 1.6;
  previewCtx.strokeStyle = 'rgba(172,161,140,0.95)';
  lines.forEach(line => {
    previewCtx.beginPath();
    previewCtx.moveTo(line.a.x, line.a.y);
    previewCtx.lineTo(line.b.x, line.b.y);
    previewCtx.stroke();
  });

  Object.values(pts).forEach(p => {
    previewCtx.beginPath();
    previewCtx.arc(p.x, p.y, 3.5, 0, Math.PI * 2);
    previewCtx.fillStyle = '#ffffff';
    previewCtx.fill();
    previewCtx.lineWidth = 1.4;
    previewCtx.strokeStyle = '#8f846d';
    previewCtx.stroke();
  });

  previewCtx.font = '600 11px "HK Grotesk", Arial, sans-serif';
  previewCtx.textBaseline = 'middle';
  lines.forEach(line => {
    const midX = (line.a.x + line.b.x) / 2;
    const midY = (line.a.y + line.b.y) / 2;
    const w = previewCtx.measureText(line.label).width;
    const pad = 6;
    let boxX = midX - (w + pad * 2) / 2;
    let boxY = midY - 20;
    if(line.side === 'below') boxY = midY + 8;
    if(line.side === 'right') { boxX = midX + 10; boxY = midY - 9; }

    previewCtx.fillStyle = 'rgba(65,64,66,0.82)';
    previewCtx.fillRect(boxX, boxY, w + pad * 2, 18);
    previewCtx.fillStyle = '#ffffff';
    previewCtx.fillText(line.label, boxX + pad, boxY + 9);
  });

  previewCtx.restore();
}

/* ---------- One-question step for faces a photo can't separate ---------- */
(function injectShapeQuestionStyles(){
  if(document.getElementById('fsqStyles')) return;
  const s = document.createElement('style');
  s.id = 'fsqStyles';
  s.textContent = `
    .fsq{margin:14px 0;padding:16px 14px;background:var(--cream,#f8f6f2);border:1px solid var(--line,rgba(65,64,66,.14));text-align:center}
    .fsq-title{font-family:var(--serif,Georgia,serif);font-size:1.15rem;font-weight:500;color:var(--dark,#414042);line-height:1.25;margin:0 0 4px}
    .fsq-sub{margin:0 0 12px;font-size:.78rem;color:var(--sage,#7e827c)}
    .fsq-options{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}
    .fsq-options.four{grid-template-columns:repeat(2,1fr)}
    .fsq-opt{display:flex;flex-direction:column;align-items:center;gap:8px;width:100%;padding:12px 6px 10px;background:var(--white,#fff);border:1px solid var(--line,rgba(65,64,66,.14));font-size:.78rem;line-height:1.3;color:var(--dark,#414042);text-align:center;cursor:pointer;transition:border-color .15s,background .15s}
    .fsq-opt svg{width:40px;height:48px;color:var(--gold-deep,#8f846d)}
    .fsq-opt:hover,.fsq-opt:focus-visible{border-color:var(--gold,#aca18c);background:#fffdf9;outline:none}
    .fsq-skip{margin-top:10px;padding:4px 0;font-size:.78rem;color:var(--sage,#7e827c);text-decoration:underline;background:none;border:none;cursor:pointer}
  `;
  document.head.appendChild(s);
})();

const SHAPE_QUESTION_OPTIONS = {
  Oval:       { label: "Soft, balanced curves",       icon: '<path d="M24 4C35 4 40 15 40 27C40 42 32 52 24 52C16 52 8 42 8 27C8 15 13 4 24 4Z"/>' },
  Heart:      { label: "Full cheeks, pointed chin",   icon: '<path d="M8 18C8 8 16 4 24 4C32 4 40 8 40 18C40 30 33 42 24 53C15 42 8 30 8 18Z"/>' },
  Triangular: { label: "Wide forehead, sharp taper",  icon: '<path d="M7 7L41 7L41 14L30 50Q24 55 18 50L7 14Z"/>' },
  Square:     { label: "Broad face, angular jaw",     icon: '<path d="M8 8L40 8L40 40L33 51L15 51L8 40Z"/>' }
};

function removeShapeQuestion(){
  const old = document.getElementById('shapeQuestion');
  if(old) old.remove();
}
resetBtn.addEventListener('click', removeShapeQuestion);
fileInput.addEventListener('change', removeShapeQuestion);
cameraInput.addEventListener('change', removeShapeQuestion);

function askShapeQuestion(verdict, onAnswer){
  removeShapeQuestion();
  const isLong = verdict.ask === 'long';
  const keys = isLong ? ['Oval', 'Heart', 'Triangular'] : ['Oval', 'Heart', 'Triangular', 'Square'];
  const title = 'Which feels most like you?';

  const box = document.createElement('div');
  box.className = 'fsq';
  box.id = 'shapeQuestion';
  box.innerHTML = `
    <h3 class="fsq-title">${title}</h3>
    <p class="fsq-sub">Every face is a blend. Pick your signature feature.</p>
    <div class="fsq-options${isLong ? '' : ' four'}">
      ${keys.map(k => `<button type="button" class="fsq-opt" data-shape="${k}"><svg viewBox="0 0 48 56" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true">${SHAPE_QUESTION_OPTIONS[k].icon}</svg><span>${SHAPE_QUESTION_OPTIONS[k].label}</span></button>`).join('')}
    </div>
    <button type="button" class="fsq-skip" data-skip="1">Not sure</button>
  `;
  box.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-shape]');
    const skip = e.target.closest('[data-skip]');
    if(!opt && !skip) return;
    const shape = opt ? opt.dataset.shape : verdict.fallback;
    removeShapeQuestion();
    onAnswer(shape);
  });
  resultsEl.parentNode.insertBefore(box, resultsEl);
  box.scrollIntoView({behavior:'smooth', block:'nearest'});
}

function showShapeResult(shape, answered){
  const whyHint = document.getElementById('shapeWhyHint');
  if(whyHint){
    whyHint.textContent = explainShape(shape, answered);
    whyHint.style.display = 'block';
  }
  setStatus('');
  renderResults(shape, null, false);
}

/* ---------- "Starting point" alert ----------
   Shown after "Estimate My Size". Opens in the middle of the screen; when dismissed it shrinks into a
   small round button at the bottom-left of the page. Tap the circle to open it again.
   ESTIMATE_ALERT.opacity: 0.8 = photo is 80% solid (page faintly shows through). Use 0.2 for 80% see-through.

   TO CHANGE THE IMAGE WITHOUT TOUCHING THIS FILE, put this in the theme (any page script, before the click):
     <script>window.ESTIMATE_ALERT_IMAGE_URL = "https://cdn.shopify.com/.../your-image.png";</script>
   Optional extra settings for a different image:
     <script>window.ESTIMATE_ALERT_CONFIG = { opacity: 0.8, buttonArea: null };</script>
   buttonArea = where the image's own "Understood" button sits, in % of the image: { left: 33.4, top: 48.4, width: 33.4, height: 6.4 }.
   Use buttonArea: null if the new image has no button painted on it; a real "Understood" button is then added at the bottom.
   The image shape (width : height) is read from the image itself. */
const ESTIMATE_ALERT = {
  src: 'https://cdn.shopify.com/s/files/1/0558/5305/6207/files/Modern_Storefront_Fit_Guide.png?v=1791524559',   /* override with window.ESTIMATE_ALERT_IMAGE_URL */
  opacity: 0.8,
  openWidth: 380,       /* px on desktop (shrinks on phones) */
  dotSize: 54,          /* px, the small round button */
  dotLeft: 16,
  dotBottom: 104,       /* px above the bottom edge (clears the reviews badge) */
  ratio: 1398 / 1125,   /* photo height / width (re-read from the image once it loads) */
  buttonArea: { left: 33.4, top: 48.4, width: 33.4, height: 6.4 },
  text: 'Consider this a starting point. For a precise fit and professional advice on size visit our showrooms or chat with us on Whatsapp.'
};
let estAlertState = 'closed';
function placeEstimateAlert(){
  const card = document.getElementById('estAlertCard');
  const dot = document.getElementById('estAlertDot');
  const back = document.getElementById('estAlertBack');
  if(!card) return;
  const W = Math.min(window.innerWidth * 0.88, ESTIMATE_ALERT.openWidth);
  const H = W * ESTIMATE_ALERT.ratio;
  card.style.width = W + 'px';
  card.style.height = H + 'px';
  const isOpen = estAlertState === 'open';
  let x, y, sc;
  if(isOpen){
    sc = 1;
    x = (window.innerWidth - W) / 2;
    y = Math.max(8, (window.innerHeight - H) / 2);
  }else{
    /* fly into the circle */
    sc = 0.08;
    x = ESTIMATE_ALERT.dotLeft + ESTIMATE_ALERT.dotSize / 2 - (W * sc) / 2;
    y = window.innerHeight - ESTIMATE_ALERT.dotBottom - ESTIMATE_ALERT.dotSize / 2 - (H * sc) / 2;
  }
  card.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + sc + ')';
  card.style.opacity = isOpen ? '1' : '0';
  card.style.pointerEvents = isOpen ? 'auto' : 'none';
  back.classList.toggle('on', isOpen);
  dot.classList.toggle('on', estAlertState === 'mini');
  card.setAttribute('role', 'alertdialog');
  card.setAttribute('aria-label', ESTIMATE_ALERT.text);
}
function ensureEstimateAlert(){
  if(document.getElementById('estAlertCard')) return;
  if(window.ESTIMATE_ALERT_CONFIG) Object.assign(ESTIMATE_ALERT, window.ESTIMATE_ALERT_CONFIG);
  if(window.ESTIMATE_ALERT_IMAGE_URL) ESTIMATE_ALERT.src = window.ESTIMATE_ALERT_IMAGE_URL;
  const A = ESTIMATE_ALERT;
  const st = document.createElement('style');
  st.textContent = `
    #estAlertBack{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.35);opacity:0;pointer-events:none;transition:opacity .3s}
    #estAlertBack.on{opacity:1;pointer-events:auto}
    #estAlertCard{position:fixed;left:0;top:0;z-index:2147483001;transform-origin:0 0;transition:transform .5s cubic-bezier(.2,.8,.2,1),opacity .35s;will-change:transform}
    #estAlertCard img{display:block;width:100%;height:100%;object-fit:cover;opacity:var(--ea-op,.8);border-radius:20px;user-select:none;-webkit-user-drag:none}
    #estAlertCard .ea-fallback{display:none;position:absolute;inset:0;box-sizing:border-box;padding:28px;border-radius:20px;background:#f1f1ee;color:#414042;font:500 17px/1.5 var(--sans,sans-serif);text-align:center;align-items:center;justify-content:center;opacity:var(--ea-op,.8)}
    #estAlertCard.noimg img{display:none}
    #estAlertCard.noimg .ea-fallback{display:flex}
    #estAlertCard .ea-btn{position:absolute;border:0;background:transparent;cursor:pointer;border-radius:999px}
    #estAlertCard .ea-btn.plain{left:50%;bottom:7%;transform:translateX(-50%);padding:11px 28px;background:#6b7266;color:#fff;font:500 15px/1 var(--sans,sans-serif);white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.25)}
    #estAlertCard .ea-btn:focus-visible{outline:2px solid #fff;outline-offset:2px}
    #estAlertCard .ea-x{position:absolute;right:12px;top:12px;width:32px;height:32px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.88);color:#414042;cursor:pointer;display:flex;align-items:center;justify-content:center}
    #estAlertCard .ea-x svg{display:block;width:12px;height:12px}
    #estAlertDot{position:fixed;z-index:2147483001;width:${A.dotSize}px;height:${A.dotSize}px;left:${A.dotLeft}px;bottom:${A.dotBottom}px;padding:0;border:2px solid #fff;border-radius:50%;background:#6b7266 50% 47%/230% auto no-repeat;box-shadow:0 4px 14px rgba(0,0,0,.28);cursor:pointer;opacity:0;transform:scale(.4);pointer-events:none;transition:opacity .3s .25s,transform .4s .25s cubic-bezier(.2,.8,.2,1)}
    #estAlertDot.on{opacity:1;transform:scale(1);pointer-events:auto}
    #estAlertDot span{position:absolute;right:-5px;top:-5px;width:20px;height:20px;border-radius:50%;background:var(--dark,#414042);color:#fff;font:600 12px/20px var(--serif,Georgia,serif);font-style:italic;text-align:center;border:1.5px solid #fff;box-sizing:border-box;line-height:17px}
    #estAlertDot:focus-visible{outline:2px solid var(--gold-deep,#8f846d);outline-offset:3px}
  `;
  document.head.appendChild(st);

  const back = document.createElement('div');
  back.id = 'estAlertBack';
  const card = document.createElement('div');
  card.id = 'estAlertCard';
  card.style.setProperty('--ea-op', A.opacity);
  card.innerHTML = '<img alt="" draggable="false">' +
    '<div class="ea-fallback"></div>' +
    '<button type="button" class="ea-btn" aria-label="Understood"></button>' +
    '<button type="button" class="ea-x" aria-label="Close"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M1.5 1.5l9 9M10.5 1.5l-9 9"/></svg></button>';
  const okBtn = card.querySelector('.ea-btn');
  if(A.buttonArea){
    okBtn.style.left = A.buttonArea.left + '%';
    okBtn.style.top = A.buttonArea.top + '%';
    okBtn.style.width = A.buttonArea.width + '%';
    okBtn.style.height = A.buttonArea.height + '%';
  }else{
    okBtn.classList.add('plain');
    okBtn.textContent = 'Understood';
  }
  const img = card.querySelector('img');
  img.addEventListener('load', () => {
    if(img.naturalWidth && img.naturalHeight){
      A.ratio = img.naturalHeight / img.naturalWidth;
      if(estAlertState !== 'closed') placeEstimateAlert();
    }
  });
  img.alt = A.text;
  img.addEventListener('error', () => {
    card.classList.add('noimg');
    card.querySelector('.ea-fallback').textContent = A.text;
  });
  img.src = A.src;
  const dot = document.createElement('button');
  dot.id = 'estAlertDot';
  dot.type = 'button';
  dot.setAttribute('aria-label', 'Read the note about this estimate again');
  dot.title = 'About this estimate';
  dot.style.backgroundImage = 'url("' + A.src + '")';
  dot.innerHTML = '<span>i</span>';
  document.body.appendChild(back);
  document.body.appendChild(card);
  document.body.appendChild(dot);

  const dock = (e) => { if(e && e.stopPropagation) e.stopPropagation(); estAlertState = 'mini'; placeEstimateAlert(); };
  card.querySelector('.ea-btn').addEventListener('click', dock);
  card.querySelector('.ea-x').addEventListener('click', dock);
  back.addEventListener('click', dock);
  dot.addEventListener('click', () => { estAlertState = 'open'; placeEstimateAlert(); });
  document.addEventListener('keydown', (e) => { if(e.key === 'Escape' && estAlertState === 'open') dock(); });
  window.addEventListener('resize', () => { if(estAlertState !== 'closed') placeEstimateAlert(); });
}
function hideEstimateAlert(){
  if(estAlertState === 'closed') return;
  estAlertState = 'closed';
  placeEstimateAlert();
}
function showEstimateAlert(){
  ensureEstimateAlert();
  const card = document.getElementById('estAlertCard');
  if(estAlertState === 'closed'){
    /* first time: start at the circle's spot with no animation, then grow open */
    card.style.transition = 'none';
    estAlertState = 'mini';
    placeEstimateAlert();
    void card.offsetWidth;
    card.style.transition = '';
  }
  estAlertState = 'open';
  placeEstimateAlert();
}

/* ---------- EYE-SIZE (lens width) ESTIMATOR ----------
   1. Scale: the iris is ~11.7 mm wide in nearly every adult, so it is the ruler (falls back to
      a 63 mm pupil distance only if the iris reading looks wrong).
   2. Distance fix: the cheekbones sit behind the iris, so a close-up photo shrinks them more than a
      far one. The iris width as a share of the photo width tells us how close the camera was.
   3. Lens width is ~0.39 x cheekbone width.
   Fitted on 12 photos of 6 people (same person, close vs far: 10 mm apart before the fix).    */
const SIZE_EST = { irisMm: 11.7, fallbackIpdMm: 63, depthK: 3.25, lensToCheek: 0.39 };
function estimateEyeSizeMm(landmarks, width, height){
  const P = (i) => pointAt(landmarks, i, width, height);
  const D = (a, b) => distance(P(a), P(b));
  const ipdPx = D(468, 473);
  if(!ipdPx || !isFinite(ipdPx)) return null;
  const irisPx = (D(469, 471) + D(474, 476)) / 2;
  const irisOk = irisPx > 0 && (irisPx / ipdPx) > 0.15 && (irisPx / ipdPx) < 0.26;
  const mmPerPx = irisOk ? SIZE_EST.irisMm / irisPx : SIZE_EST.fallbackIpdMm / ipdPx;
  const closeness = irisOk ? irisPx / width : 0.03;          /* bigger = camera closer */
  const cheekMm = D(234, 454) * mmPerPx * (1 + SIZE_EST.depthK * closeness);
  return { eyeMm: Math.round(cheekMm * SIZE_EST.lensToCheek), cheekMm: Math.round(cheekMm), irisOk: irisOk };
}

/* ---------- SIZE DATA LOGGER (temporary, for tuning the size estimator) ----------
   Before each photo, tell the page who it is:
     sz(52, 18, 'F', 'Oval', 'Round', 'p01')
        eye size mm, bridge mm, gender (F/M/K), face shape, frame shape the eye size belongs to, person id
   Then upload + analyse. When done:  copy(szCSV())  and paste the result in the chat.   */
window.__szLog = window.__szLog || [];
window.szTrue = window.szTrue || null;
window.sz = function(mm, bridge, gender, faceShape, frame, id){
  window.szTrue = { mm: mm, bridge: bridge, gender: gender, faceShape: faceShape, frame: frame, id: id };
  console.log('[Size Debug] next photos are logged as', window.szTrue);
};
function logSizeSample(landmarks, width, height, verdict){
  try{
    const P = (i) => pointAt(landmarks, i, width, height);
    const D = (a, b) => distance(P(a), P(b));
    const irisH = (D(469, 471) + D(474, 476)) / 2;
    const irisV = (D(470, 472) + D(475, 477)) / 2;
    const ipd = D(468, 473);
    const nose = 1;
    const t = window.szTrue || {};
    const roll = Math.atan2(P(473).y - P(468).y, P(473).x - P(468).x) * 180 / Math.PI;
    const row = {
      id: t.id || '', trueMm: t.mm === undefined ? '' : t.mm, bridge: t.bridge === undefined ? '' : t.bridge,
      gender: t.gender || '', manualShape: t.faceShape || '', frame: t.frame || '',
      irisH: irisH, irisV: irisV, ipd: ipd,
      cheek: D(234, 454), temple: D(127, 356), lowCheek: D(93, 323), forehead: D(21, 251), jaw: D(58, 288),
      eyeOuter: D(33, 263), eyeInner: D(133, 362), faceLen: D(10, 152),
      yawRatio: D(nose, 234) / D(nose, 454), rollDeg: Math.abs(roll),
      oldEstimate: Math.round(D(234, 454) * (63 / ipd) * 0.385),
      newEstimate: (estimateEyeSizeMm(landmarks, width, height) || {}).eyeMm,
      autoShape: verdict && verdict.shape ? verdict.shape : '?',
      imgW: width, imgH: height
    };
    window.__szLog.push(row);
    console.log('[Size Debug] logged', row.id, 'rows so far:', window.__szLog.length);
  }catch(e){ console.warn('size log failed', e); }
}
window.szCSV = function(){
  const rows = window.__szLog;
  if(!rows.length) return '';
  const cols = Object.keys(rows[0]);
  const f = (v) => (typeof v === 'number' && !Number.isInteger(v)) ? v.toFixed(4) : v;
  return [cols.join(',')].concat(rows.map(r => cols.map(c => f(r[c])).join(','))).join('\n');
};

/* ---------- Lead capture: name + email popup shown over the results ---------- */
/* Saves the visitor as a Shopify customer (tag "face-tool") in the background, without leaving the page.
   To tweak the look or wording without editing this file, set window.LEAD_GATE_CONFIG = {...} before this script loads. */
const LEAD = {
  sheetUrl: 'https://script.google.com/a/macros/srgopalrao.com/s/AKfycbzXdit2gDvtmE4Vg8UEVsVFYejo0TWKt3jzsCTZv89rsYtnwZBAVsuz3o2CRG0Fxo9N/exec',   // paste your Google Apps Script web app link here (ends in /exec)
  backdrop: 'rgba(20,20,20,.28)', // how much the page behind is dimmed
  cardOpacity: 0.88,              // 1 = solid card, lower = more see-through
  blur: 8,                        // px of blur on the card's glass effect (0 = none)
  title: 'See your face shape',
  sub: 'Enter your name and email to see your results.',
  newsletterLabel: 'Subscribe to our newsletter',
  privacy: 'We respect your privacy. Your details are kept safe and are never shared.',
  privacyLinkText: 'Privacy Policy',
  privacyUrl: '/policies/privacy-policy',
  button: 'Show my results'
};
if(window.LEAD_GATE_CONFIG) Object.assign(LEAD, window.LEAD_GATE_CONFIG);

const LEAD_FLAG = 'fsiLeadDone';
let leadDoneMem = false;
function leadAlreadyDone(){
  if(leadDoneMem) return true;
  try{ return sessionStorage.getItem(LEAD_FLAG) === '1'; }catch(e){ return false; }
}
function markLeadDone(){
  leadDoneMem = true;
  try{ sessionStorage.setItem(LEAD_FLAG, '1'); }catch(e){}
}
/* For testing: run fsiLeadReset() in the browser console to see the popup again. */
window.fsiLeadReset = function(){ leadDoneMem = false; try{ sessionStorage.removeItem(LEAD_FLAG); }catch(e){} };

function escAttr(s){ return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

function ensureLeadGate(){
  let back = document.getElementById('leadBack');
  if(back) return back;

  const st = document.createElement('style');
  st.id = 'leadStyles';
  st.textContent = `
    #leadBack{position:fixed;inset:0;z-index:2147482000;display:none;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;background:${LEAD.backdrop}}
    #leadBack.on{display:flex}
    #leadCard{width:100%;max-width:400px;box-sizing:border-box;padding:26px 24px 20px;border-radius:14px;background:rgba(255,255,255,${LEAD.cardOpacity});-webkit-backdrop-filter:blur(${LEAD.blur}px);backdrop-filter:blur(${LEAD.blur}px);box-shadow:0 18px 50px rgba(0,0,0,.22);border:1px solid rgba(255,255,255,.6);color:var(--dark,#414042);font-family:var(--sans,inherit);text-align:center;animation:leadIn .35s cubic-bezier(.2,.8,.2,1)}
    @keyframes leadIn{from{opacity:0;transform:translateY(14px) scale(.98)}to{opacity:1;transform:none}}
    #leadCard h3{margin:0 0 6px;font-family:var(--serif,Georgia,serif);font-size:1.4rem;font-weight:500;line-height:1.2;color:var(--dark,#414042)}
    #leadCard .lead-sub{margin:0 0 16px;font-size:.85rem;color:var(--sage,#7e827c);line-height:1.4}
    #leadCard .lead-field{display:block;margin:0 0 10px;text-align:left}
    #leadCard .lead-field input{display:block;width:100%;box-sizing:border-box;padding:13px 14px;font:inherit;font-size:16px;color:var(--dark,#414042);background:rgba(255,255,255,.9);border:1px solid var(--line,rgba(65,64,66,.25));border-radius:0;outline:none;transition:border-color .15s}
    #leadCard .lead-field input:focus{border-color:var(--gold-deep,#8f846d)}
    #leadCard .lead-field.err input{border-color:#b3382c}
    #leadCard .lead-msg{display:none;margin:4px 0 0;font-size:.76rem;color:#b3382c}
    #leadCard .lead-field.err .lead-msg{display:block}
    #leadCard .lead-check{display:flex;align-items:flex-start;gap:9px;margin:4px 0 14px;text-align:left;font-size:.85rem;line-height:1.35;color:var(--dark,#414042);cursor:pointer}
    #leadCard .lead-check input{flex:none;width:17px;height:17px;margin:1px 0 0;accent-color:var(--dark,#414042);cursor:pointer}
    #leadCard .lead-go{display:block;width:100%;padding:14px 10px;font:inherit;font-size:.8rem;letter-spacing:.16em;text-transform:uppercase;color:#fff;background:var(--dark,#414042);border:0;border-radius:0;cursor:pointer;transition:opacity .15s}
    #leadCard .lead-go:hover{opacity:.88}
    #leadCard .lead-go:disabled{opacity:.5;cursor:default}
    #leadCard .lead-privacy{margin:12px 0 0;font-size:.72rem;line-height:1.4;color:var(--sage,#7e827c)}
    #leadCard .lead-privacy a{color:inherit;text-decoration:underline}
    @media (max-width:600px){
      #leadBack{align-items:flex-end;padding:0}
      #leadCard{max-width:none;border-radius:16px 16px 0 0;padding:22px 18px calc(18px + env(safe-area-inset-bottom))}
    }
  `;
  document.head.appendChild(st);

  back = document.createElement('div');
  back.id = 'leadBack';
  back.innerHTML = `
    <form id="leadCard" role="dialog" aria-modal="true" aria-labelledby="leadTitle" novalidate>
      <h3 id="leadTitle">${escAttr(LEAD.title)}</h3>
      <p class="lead-sub">${escAttr(LEAD.sub)}</p>
      <div class="lead-field" id="leadNameWrap">
        <input type="text" id="leadName" name="name" autocomplete="name" placeholder="Your name" aria-label="Your name" maxlength="80">
        <p class="lead-msg">Please enter your name.</p>
      </div>
      <div class="lead-field" id="leadEmailWrap">
        <input type="email" id="leadEmail" name="email" autocomplete="email" inputmode="email" placeholder="Your email" aria-label="Your email" maxlength="120">
        <p class="lead-msg">Please enter a valid email address.</p>
      </div>
      <label class="lead-check"><input type="checkbox" id="leadNews"><span>${escAttr(LEAD.newsletterLabel)}</span></label>
      <button type="submit" class="lead-go" id="leadGo">${escAttr(LEAD.button)}</button>
      <p class="lead-privacy">${escAttr(LEAD.privacy)} <a href="${escAttr(LEAD.privacyUrl)}" target="_blank" rel="noopener">${escAttr(LEAD.privacyLinkText)}</a></p>
    </form>`;
  document.body.appendChild(back);

  const form = back.querySelector('#leadCard');
  const nameIn = back.querySelector('#leadName');
  const emailIn = back.querySelector('#leadEmail');
  const nameWrap = back.querySelector('#leadNameWrap');
  const emailWrap = back.querySelector('#leadEmailWrap');
  const newsIn = back.querySelector('#leadNews');

  nameIn.addEventListener('input', () => nameWrap.classList.remove('err'));
  emailIn.addEventListener('input', () => emailWrap.classList.remove('err'));

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = nameIn.value.trim().replace(/\s+/g, ' ');
    const email = emailIn.value.trim();
    const nameOk = name.length >= 2;
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    nameWrap.classList.toggle('err', !nameOk);
    emailWrap.classList.toggle('err', !emailOk);
    if(!nameOk){ nameIn.focus(); return; }
    if(!emailOk){ emailIn.focus(); return; }
    markLeadDone();
    closeLeadGate();
    saveLead({ name, email, news: newsIn.checked });
  });
  /* No close button, Esc handler or backdrop click on purpose: the details are needed to continue. */
  return back;
}

function openLeadGate(){
  if(leadAlreadyDone()) return;
  const back = ensureLeadGate();
  back.classList.add('on');
  /* Don't pop the phone keyboard open straight away; let people see the results behind first. */
  if(window.matchMedia && !window.matchMedia('(max-width:600px)').matches){
    setTimeout(() => { const n = document.getElementById('leadName'); if(n) n.focus(); }, 60);
  }
}
function closeLeadGate(){
  const back = document.getElementById('leadBack');
  if(back) back.classList.remove('on');
}

/* Saves the contact to a Google Sheet (through a small Google Apps Script web app) in the background.
   The visitor never leaves the page, and a failure never blocks them. Paste the web app link into LEAD.sheetUrl above. */
let leadPending = null, leadPosted = false, leadShapeSent = '', leadShapeNow = null, leadShapeTimer = null;

function saveLead(lead){
  leadPending = lead;
  leadPosted = false;
  /* Wait for the face shape so it goes into the sheet with the name and email; don't wait forever. */
  if(leadShapeNow){ postLead(leadShapeNow); }
  else{ clearTimeout(leadShapeTimer); leadShapeTimer = setTimeout(() => { if(!leadPosted) postLead(''); }, 25000); }
}

/* Called every time a face shape result is shown (analysis, or the follow-up question, or a manual pick). */
function leadShapeReady(shape){
  leadShapeNow = shape;
  if(!leadPending) return;
  if(!leadPosted){ clearTimeout(leadShapeTimer); postLead(shape); }
  else if(shape && shape !== leadShapeSent){ postLead(shape); }   /* they changed shape: update the same row */
}

function postLead(shape){
  const lead = leadPending;
  const url = String(LEAD.sheetUrl || '').trim();
  if(!lead) return;
  if(!url){
    console.warn('[Lead] no sheet link set (LEAD.sheetUrl), so the contact was not saved');
    window.__fsiLeadResult = { sent: false, reason: 'no-url' };
    return;
  }
  leadPosted = true;
  leadShapeSent = shape || '';
  const body = new URLSearchParams();
  body.set('name', lead.name);
  body.set('email', lead.email);
  body.set('news', lead.news ? 'yes' : 'no');
  body.set('shape', shape || '');
  body.set('source', location.pathname);
  body.set('website', '');   /* hidden trap field: real visitors never fill it, spam bots do */
  const send = (attempt) => {
    fetch(url, { method: 'POST', mode: 'no-cors', body: body })
      .then(() => { window.__fsiLeadResult = { sent: true, news: !!lead.news, shape: shape || '' }; console.log('[Lead] sent to the sheet', window.__fsiLeadResult); })
      .catch(err => {
        if(attempt < 2){ setTimeout(() => send(attempt + 1), 3000); }
        else{ console.warn('[Lead] could not reach the sheet', err); window.__fsiLeadResult = { sent: false, reason: 'network' }; }
      });
  };
  send(1);
}

analyzeBtn.addEventListener('click', async () => {
  if(!sourceImage){ setStatus('Take a photo first.', true); return; }

  leadShapeNow = null;  /* forget any earlier result so only this photo's shape is sent */
  openLeadGate();  /* name + email popup over the results; analysis keeps running behind it */

  removeShapeQuestion();
  analyzeBtn.disabled = true;
  resetBtn.disabled = true;
  scanLine.style.display = 'block';
  setStatus('Preparing analysis…');
  resultsEl.style.display = 'none';
  mapHint.style.display = 'none';
  const whyHintEl = document.getElementById('shapeWhyHint');
  if(whyHintEl) whyHintEl.style.display = 'none';

  try{
    await loadLandmarker();
    setStatus('Analysing your face shape…');

    const result = faceLandmarker.detect(previewCanvas);
    if(!result.faceLandmarks || result.faceLandmarks.length === 0){
      throw new Error('no-face');
    }

    const landmarks = result.faceLandmarks[0];
    lastLandmarks = { landmarks, width: previewCanvas.width, height: previewCanvas.height };
    const verdict = classifyFaceShape(landmarks, previewCanvas.width, previewCanvas.height);
    logSizeSample(landmarks, previewCanvas.width, previewCanvas.height, verdict);

    drawBaseImage(sourceImage);
    drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_FACE_OVAL, { color: '#aca18c', lineWidth: 3 });
    drawMeasurementOverlay(landmarks, previewCanvas.width, previewCanvas.height);
    mapHint.style.display = 'block';

    if(verdict.shape){
      showShapeResult(verdict.shape, false);
    }else{
      setStatus('');
      askShapeQuestion(verdict, (shape) => showShapeResult(shape, true));
    }

  }catch(err){
    console.error(err);
    const msg = err && err.message === 'no-face'
      ? "We couldn't spot a clear, front-facing face in that photo — please try another, following the tips above."
      : "We couldn't complete the analysis — please try a clearer, front-facing photo.";
    closeLeadGate();  /* nothing to show, so don't ask for details */
    setStatus(msg, true);
  }finally{
    analyzeBtn.disabled = false;
    resetBtn.disabled = false;
    scanLine.style.display = 'none';
  }
});

const genericFrameIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="7" cy="12" r="4"/><circle cx="17" cy="12" r="4"/><path d="M11 12h2M3 12l1.5-2M21 12l-1.5-2"/></svg>';

async function fetchFirstProduct(style, category){
  if(!style.productsJsonUrl) return null;
  try{
    const res = await fetch(style.productsJsonUrl);
    if(!res.ok) throw new Error('bad response: ' + res.status);
    const data = await res.json();
    let products = data.products || [];
    products = products.filter(p => (p.variants || []).some(v => v.available));
    if(category) products = products.filter(p => productCategory(p) === category);
    if(style.tag){
      products = products.filter(p => (p.tags || []).some(t => t.toLowerCase() === style.tag.toLowerCase()));
    }
    const first = products[0];
    if(!first) return null;
    const image = first.images && first.images[0] ? first.images[0].src : null;
    return { title: first.title, image, url: `https://www.shop-srgopalrao.co/products/${first.handle}` };
  }catch(err){
    console.warn('Could not load a product preview for', style.name, err);
    return null;
  }
}

async function loadThumb(thumbEl, style, category){
  const product = await fetchFirstProduct(style, category);
  thumbEl.classList.remove('loading');
  if(product && product.image){
    thumbEl.innerHTML = `<img src="${product.image}" alt="${product.title || style.name}" loading="lazy">`;
  }
}

/* ---------- Step 1: face shape result + Step 2: gender gate ---------- */
const genderStep = document.getElementById('genderStep');
const styleResultsEl = document.getElementById('styleResults');

function renderResults(shape, reasoning, manual){
  window.fitProfile.faceShape = shape;
  leadShapeReady(shape);
  window.fitProfile.gender = null;
  window.fitProfile.styles = FACE_SHAPES[shape].frames.slice();
  window.fitProfile.size = null;
  window.fitProfile.sizeCategory = null;
  window.fitProfile.sizeShape = null;

  document.getElementById('resultEyebrow').textContent = manual ? 'Frames For' : 'Your Face Shape';
  document.getElementById('resultShape').textContent = shape;
  document.getElementById('resultReasoning').textContent = reasoning || FACE_SHAPES[shape].tagline;

  document.querySelectorAll('.gender-card').forEach(c => c.classList.remove('selected'));
  styleResultsEl.classList.remove('show');
  document.getElementById('genderChangedNote').classList.remove('show');

  resultsEl.style.display = 'block';
  resultsEl.scrollIntoView({behavior:'smooth', block:'nearest'});

  updateFitProfilePanel();
}

const FEMALE_ONLY_STYLES = ['cat-eye', 'butterfly']; // shown for Women and Others, never for Men

genderStep.addEventListener('click', (e) => {
  const btn = e.target.closest('.gender-card');
  if(!btn) return;
  const fp = window.fitProfile;
  const changed = fp.gender && fp.gender !== btn.dataset.gender;
  fp.gender = btn.dataset.gender;
  fp.styles = FACE_SHAPES[fp.faceShape].frames.filter(k =>
    fp.gender === 'Men' ? !FEMALE_ONLY_STYLES.includes(k) : true
  );
  document.querySelectorAll('.gender-card').forEach(c => c.classList.toggle('selected', c === btn));
  renderStyleGrid(fp.faceShape, fp.styles);
  document.getElementById('genderChangedNote').classList.toggle('show', !!changed);
  updateFitProfilePanel();
});

function renderStyleGrid(shape, overrideFrames){
  const allKeys = overrideFrames || FACE_SHAPES[shape].frames;
  const topKeys = allKeys.slice(0, 3);
  const topNames = topKeys.map(k => FRAME_STYLES[k] ? FRAME_STYLES[k].name : k);
  const extraCount = allKeys.length - topKeys.length;

  const medalLine = topNames.map((name, i) => `${MEDALS[i]} ${name}`).join('&nbsp;&nbsp;·&nbsp;&nbsp;');
  const noteText = extraCount > 0
    ? `+ ${extraCount} more style${extraCount > 1 ? 's' : ''} that suit your ${shape.toLowerCase()} face — see them all, check your size and shop below.`
    : `See them, check your size and shop below.`;

  document.getElementById('styleSummary').innerHTML = `${medalLine}<br><span class="style-summary-note">${noteText}</span>`;
  styleResultsEl.classList.add('show');
}

document.getElementById('shopRecGrid').addEventListener('click', (e) => {
  const card = e.target.closest('.rec-card');
  if(card) openModal(card.dataset.style);
});

/* ---------- Fit popup: eye-size branching ---------- */
const modalOverlay = document.getElementById('fitModalOverlay');
const modalBody = document.getElementById('modalBody');
let modalStyleKey = null;

function openModal(styleKey){
  if(!window.fitProfile.gender){ return; }
  modalStyleKey = styleKey;
  renderModalStage('ask');
  modalOverlay.classList.add('show');
}
function closeModal(){
  hideEstimateAlert();
  modalOverlay.classList.remove('show');
  modalBody.innerHTML = '';
  modalStyleKey = null;
}
document.getElementById('modalClose').addEventListener('click', closeModal);
modalOverlay.addEventListener('click', (e) => { if(e.target === modalOverlay) closeModal(); });
document.addEventListener('keydown', (e) => {
  if(e.key === 'Escape' && modalOverlay.classList.contains('show')) closeModal();
  if(e.key === 'Escape' && tryOnOverlay.classList.contains('show')) tryOnOverlay.classList.remove('show');
});

function styleName(){ return (FRAME_STYLES[modalStyleKey] || {}).name || ''; }

function renderModalStage(stage){
  hideEstimateAlert();   /* the note and its small circle only belong to the photo-estimate screen */
  const fp = window.fitProfile;

  if(stage === 'ask'){
    modalBody.innerHTML = `
      <span class="eyebrow">${styleName()} · Frame Size</span>
      <h3>Do you know your eye size?</h3>
      <p>It's the first number etched inside the temple arm or bridge of a pair of glasses you already own.</p>
      <div class="fitpop-etched">
        <div class="fitpop-etched-row">
          <span class="num hero-num">52</span>
          <span class="div">▢</span>
          <span class="num">18</span>
          <span class="num">140</span>
        </div>
        <div class="fitpop-etched-labels">
          <span class="highlight">52 = Eye Size</span>
          <span>18 = Bridge</span>
          <span>140 = Temple Length</span>
        </div>
        <p class="fitpop-etched-hint">Flip your current pair over — it's stamped right there. Knowing it lets us narrow today's picks down to Small, Medium or Large.</p>
      </div>
      <div class="fitpop-actions">
        <button class="btn-primary" id="modalYes">Yes, I know it</button>
        <button class="btn-secondary" id="modalNo">No, not sure</button>
      </div>
    `;
    document.getElementById('modalYes').addEventListener('click', () => renderModalStage('manual'));
    document.getElementById('modalNo').addEventListener('click', () => renderModalStage('no-options'));
    return;
  }

  if(stage === 'manual'){
    modalBody.innerHTML = `
      <span class="eyebrow">${styleName()}</span>
      <h3>Check My Size</h3>
      <p class="cat-note">${CATEGORY_LABEL[window.fitProfile.category]} only</p>
      <div class="size-check-row">
        <input type="hidden" id="modalCategory" value="${window.fitProfile.category}">
        <div class="size-check-field">
          <label for="modalSizeInput">Your Eye Size (mm)</label>
          <input type="number" id="modalSizeInput" placeholder="e.g. 52" inputmode="numeric" min="1">
        </div>
        <div class="size-check-field">
          <label for="modalBridgeInput">Nose Bridge (mm) <span class="optional-tag">optional</span></label>
          <input type="number" id="modalBridgeInput" placeholder="e.g. 18" inputmode="numeric" min="1">
        </div>
      </div>
      <button class="btn-primary" id="modalCheckBtn" type="button" style="width:100%;">Check My Size</button>
      <div class="size-result" id="modalSizeResult"></div>
      <div class="fitpop-actions" id="modalResultActions" style="display:none;"></div>
    `;

    document.getElementById('modalCheckBtn').addEventListener('click', () => {
      const category = document.getElementById('modalCategory').value;
      const shapeLabel = frameShapeLabelFor(modalStyleKey);
      const val = parseFloat(document.getElementById('modalSizeInput').value);
      const bridgeVal = parseFloat(document.getElementById('modalBridgeInput').value);
      if(isNaN(val) || val <= 0){
        showModalSizeMessage('Enter your eye size in millimetres first.', true);
        return;
      }
      const bounds = window.SIZE_CHART[category][shapeLabel];
      const { size, bridgeAdjusted } = resolveSize(val, bounds, bridgeVal);
      let note = `${shapeLabel} (${category === 'optical' ? 'optical frame' : 'sunglasses'}) → ${size}`;
      if (bridgeAdjusted) note += ` — adjusted up for a wider nose bridge`;
      applyResolvedSize(category, shapeLabel, size, note);
    });
    return;
  }

  if(stage === 'no-options'){
    const waHref = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    modalBody.innerHTML = `
      <span class="eyebrow">${styleName()}</span>
      <h3>No problem — how would you like to find it?</h3>
      <p>Pick whichever's easiest for you.</p>
      <div class="fitpop-actions" style="flex-direction:column;">
        <a class="btn-primary" id="modalWhatsapp" href="${waHref}" target="_blank" rel="noopener" style="width:100%;justify-content:center;">Chat On WhatsApp</a>
        <button class="btn-secondary" id="modalEstimateOption" style="width:100%;">Estimate From My Photo</button>
        <button class="btn-ghost" id="modalNotNow" style="width:100%;">No, not now</button>
      </div>
    `;
    document.getElementById('modalEstimateOption').addEventListener('click', () => renderModalStage('estimate'));
    document.getElementById('modalNotNow').addEventListener('click', () => renderModalStage('final-options'));
    return;
  }

  if(stage === 'estimate'){
    modalBody.innerHTML = `
      <span class="eyebrow">${styleName()}</span>
      <h3>Estimate From My Photo</h3>
      <p class="cat-note">${CATEGORY_LABEL[window.fitProfile.category]} only</p>
      <div id="modalEstimateMissing" style="font-size:0.82rem;color:var(--sage);margin-bottom:16px;">${lastLandmarks ? '' : "No photo on file yet — this option needs the photo from Step 1."}</div>
      <div id="modalEstimateReady" style="display:${lastLandmarks ? 'block' : 'none'};">
        <div class="size-check-row">
          <input type="hidden" id="modalEstCategory" value="${window.fitProfile.category}">
          <div class="size-check-field">
            <label for="modalEstBridgeInput">Nose Bridge (mm) <span class="optional-tag">optional</span></label>
            <input type="number" id="modalEstBridgeInput" placeholder="e.g. 18" inputmode="numeric" min="1">
          </div>
        </div>
        <button class="btn-primary" id="modalEstimateBtn" type="button" style="width:100%;">Estimate My Size</button>
      </div>
      <div class="size-result" id="modalSizeResult"></div>
      <div class="fitpop-actions" id="modalResultActions" style="display:none;"></div>
      <button class="btn-ghost" id="modalEstimateBack" style="width:100%;margin-top:10px;">Back</button>
    `;

    const estimateBtn = document.getElementById('modalEstimateBtn');
    if(estimateBtn){
      estimateBtn.addEventListener('click', () => {
        const category = document.getElementById('modalEstCategory').value;
        const shapeLabel = frameShapeLabelFor(modalStyleKey);
        const bridgeVal = parseFloat(document.getElementById('modalEstBridgeInput').value);
        const { landmarks, width, height } = lastLandmarks;
        const est = estimateEyeSizeMm(landmarks, width, height);
        if(!est){
          showModalSizeMessage("Couldn't read that photo clearly enough — try WhatsApp instead.", true);
          return;
        }
        const estimatedEyeSize = est.eyeMm;
        console.log('[Size Estimate Debug]', est);
        const bounds = window.SIZE_CHART[category][shapeLabel];
        const { size, bridgeAdjusted } = resolveSize(estimatedEyeSize, bounds, bridgeVal);
        let note = `${shapeLabel} → ${size}`;
        if(bridgeAdjusted) note += ` — adjusted up for a wider nose bridge`;
        applyResolvedSize(category, shapeLabel, size, note, true);
        showEstimateAlert();
      });
    }
    document.getElementById('modalEstimateBack').addEventListener('click', () => renderModalStage('no-options'));
    return;
  }

  if(stage === 'final-options'){
    const generalUrl = buildGenderUrl(modalStyleKey, fp.gender);
    modalBody.innerHTML = `
      <span class="eyebrow">${styleName()}</span>
      <h3>No problem — where would you like to go?</h3>
      <div class="fitpop-actions">
        <button class="btn-secondary" id="modalBack">Back</button>
        <a class="btn-primary" id="modalContinue" href="${generalUrl}" target="_blank" rel="noopener">Continue Browsing</a>
      </div>
    `;
    document.getElementById('modalBack').addEventListener('click', () => renderModalStage('ask'));
    document.getElementById('modalContinue').addEventListener('click', () => closeModal());
    return;
  }
}

const LARGE_BRIDGE_THRESHOLD_MM = 19;

function resolveSize(eyeSizeMm, bounds, bridgeMm){
  let size = eyeSizeMm <= bounds[0] ? 'Small' : (eyeSizeMm <= bounds[1] ? 'Medium' : 'Large');
  let bridgeAdjusted = false;
  if(!isNaN(bridgeMm) && bridgeMm >= LARGE_BRIDGE_THRESHOLD_MM){
    if(size === 'Small'){ size = 'Medium'; bridgeAdjusted = true; }
    else if(size === 'Medium'){ size = 'Large'; bridgeAdjusted = true; }
  }
  return { size, bridgeAdjusted };
}

function showModalSizeMessage(msg, isError){
  const el = document.getElementById('modalSizeResult');
  el.innerHTML = `<p class="size-result-note" style="color:${isError ? '#a04a3d' : 'var(--sage)'};">${msg}</p>`;
  el.classList.add('show');
}

async function applyResolvedSize(category, shapeLabel, size, noteText, isEstimate=false){
  const fp = window.fitProfile;
  fp.size = size;
  fp.sizeCategory = category;
  fp.sizeShape = shapeLabel;

  const resultEl = document.getElementById('modalSizeResult');
  const disclaimer = isEstimate
    ? `<p class="size-disclaimer">This is an indicative estimate only — for a confirmed, professional fitting, please visit an SRGR boutique.</p>`
    : '';
  const edgeSizeNote = (size === 'Small' || size === 'Large')
    ? `<p class="size-edge-note">${size} sits at the edge of our sizing ranges — a wider nose bridge can comfortably push this into a Medium, so it's worth trying nearby sizes too if you're unsure.</p>`
    : '';
  resultEl.innerHTML = `<div class="size-result-badge">${size}</div><p class="size-result-note">${noteText}</p>${edgeSizeNote}${disclaimer}`;  resultEl.classList.add('show');

  const actions = document.getElementById('modalResultActions');
  actions.innerHTML = `<p style="font-size:0.82rem;color:var(--sage);">Finding frames that actually match this size…</p>`;
  actions.style.display = 'block';

  await sizeMapLoading;
  const matches = await fetchMatchingProducts(modalStyleKey, fp.gender, size);

  if(matches.length){
    actions.innerHTML = `
      <div class="fitpop-product-list">
        ${matches.map((m, i) => `
          <div class="tryon-product-card">
            <a href="${m.url}" target="_blank" rel="noopener">
              <div class="fitpop-product-thumb">${m.image ? `<img src="${m.image}" alt="${m.title}" loading="lazy">` : genericFrameIcon}</div>
              <span>${m.title}</span>
            </a>
            ${m.image ? `<button type="button" class="btn-ghost tryon-open-btn" data-index="${i}" style="width:100%;margin-top:6px;padding:8px;font-size:0.68rem;">Try It On</button>` : ''}
          </div>
        `).join('')}
      </div>
      <p style="font-size:0.72rem;color:var(--sage);margin-top:2px;">Matched to a ${size} ${shapeLabel.toLowerCase()} fit, from our live stock. Swipe or use the arrows to flip through your matches.</p>
    `;
    currentTryOnMatches = matches;
    currentTryOnSize = size;
    actions.querySelectorAll('.tryon-open-btn').forEach(btn => {
      btn.addEventListener('click', () => openTryOn(parseInt(btn.dataset.index, 10)));
    });
  } else {
    const generalUrl = buildGenderUrl(modalStyleKey, fp.gender);
    actions.innerHTML = `
      <p style="font-size:0.82rem;color:var(--sage);margin-bottom:14px;">We don't have an exact ${size} match in ${shapeLabel} in stock right now.</p>
      <a class="btn-primary" href="${generalUrl}" target="_blank" rel="noopener" style="width:100%;justify-content:center;">Browse All ${shapeLabel} Styles ${arrowSvg}</a>
    `;
  }

  updateFitProfilePanel();
}

/* ---------- Try It On: swipeable auto-fitted straight-on view ----------
   Position/size/angle come from the same face landmarks used for the
   face-shape scan. Glasses images are checked for a white/near-white
   background first (isLikelyWhiteBackground) — anything else is
   rejected rather than shown looking broken, since the cutout only
   works cleanly on catalog-style product photography. */
const tryOnOverlay = document.getElementById('tryOnOverlay');
const tryOnImageCache = {};
let currentTryOnMatches = [];
let currentTryOnSize = null;
let currentTryOnIndex = 0;

function isLikelyWhiteBackground(ctx, w, h){
  const sample = Math.max(4, Math.round(Math.min(w, h) * 0.03));
  const corners = [
    [0, 0], [w - sample, 0], [0, h - sample], [w - sample, h - sample]
  ];
  let total = 0, count = 0;
  corners.forEach(([sx, sy]) => {
    const data = ctx.getImageData(sx, sy, sample, sample).data;
    for(let i = 0; i < data.length; i += 4){
      total += (data[i] + data[i+1] + data[i+2]) / 3;
      count++;
    }
  });
  return count > 0 && (total / count) > 235;
}

function processGlassesImage(imgUrl){
  if(Object.prototype.hasOwnProperty.call(tryOnImageCache, imgUrl)){
    return Promise.resolve(tryOnImageCache[imgUrl]);
  }
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try{
        const canvas = document.createElement('canvas');
        const w = img.naturalWidth, h = img.naturalHeight;
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        if(!isLikelyWhiteBackground(ctx, w, h)){
          tryOnImageCache[imgUrl] = null;
          resolve(null);
          return;
        }

        const imageData = ctx.getImageData(0, 0, w, h);
        const data = imageData.data;
        for(let i = 0; i < data.length; i += 4){
          const r = data[i], g = data[i+1], b = data[i+2];
          const brightness = (r + g + b) / 3;
          if(brightness > 235){ data[i+3] = 0; }
          else if(brightness > 205){ data[i+3] = Math.round(data[i+3] * (1 - (brightness - 205) / 30)); }
        }

        ctx.putImageData(imageData, 0, 0);
        const result = canvas.toDataURL('image/png');
        tryOnImageCache[imgUrl] = result;
        resolve(result);
      }catch(err){
        console.warn('Glasses image processing failed (likely a CORS-restricted image) — using the original photo instead.', err);
        resolve(imgUrl);
      }
    };
    img.onerror = () => { tryOnImageCache[imgUrl] = null; resolve(null); };
    img.src = imgUrl;
  });
}

function getCleanPhotoDataUrl(){
  if(!sourceImage) return null;
  const tmp = document.createElement('canvas');
  const scale = Math.min(PREVIEW_MAX_DIM / sourceImage.naturalWidth, PREVIEW_MAX_DIM / sourceImage.naturalHeight, 1);
  tmp.width = Math.round(sourceImage.naturalWidth * scale);
  tmp.height = Math.round(sourceImage.naturalHeight * scale);
  tmp.getContext('2d').drawImage(sourceImage, 0, 0, tmp.width, tmp.height);
  return tmp.toDataURL('image/jpeg', 0.9);
}

function computeAutoFit(){
  if(!lastLandmarks) return null;
  const { landmarks, width, height } = lastLandmarks;
  const irisL = pointAt(landmarks, LM.irisL, width, height);
  const irisR = pointAt(landmarks, LM.irisR, width, height);
  const cheekL = pointAt(landmarks, LM.cheekL, width, height);
  const cheekR = pointAt(landmarks, LM.cheekR, width, height);
  const cheekWidthPx = distance(cheekL, cheekR);
  const angleRad = Math.atan2(irisR.y - irisL.y, irisR.x - irisL.x);
  // +21 = 7 manual "+" clicks worth (3 each), baked in as the starting size
  return {
    xPct: ((irisL.x + irisR.x) / 2 / width) * 100,
    yPct: ((irisL.y + irisR.y) / 2 / height) * 100,
    widthPct: (cheekWidthPx * 0.74 / width) * 100 + 21,
    angleDeg: angleRad * (180 / Math.PI)
  };
}

function applyTryonTransform(slot){
  const state = slot.__tryonState;
  const glasses = slot.querySelector('.tryon-glasses');
  glasses.style.left = state.xPct + '%';
  glasses.style.top = state.yPct + '%';
  glasses.style.width = state.widthPct + '%';
  glasses.style.transform = `translate(-50%, -50%) rotate(${state.angleDeg}deg)`;
}

async function openTryOn(index){
  currentTryOnIndex = index;
  const slot = document.getElementById('tryonSlotFront');
  const photo = slot.querySelector('.tryon-photo');
  const glasses = slot.querySelector('.tryon-glasses');
  const controls = document.getElementById('tryonControls');
  const noPhotoHint = document.getElementById('tryonNoPhotoHint');
  const notWhiteHint = document.getElementById('tryonNotWhiteHint');
  const sizeReadout = document.getElementById('tryonSizeReadout');
  const navPrev = document.getElementById('tryonNavPrev');
  const navNext = document.getElementById('tryonNavNext');
  const navCounter = document.getElementById('tryonNavCounter');

  const match = currentTryOnMatches[currentTryOnIndex];
  const hasMultiple = currentTryOnMatches.length > 1;
  navPrev.style.display = hasMultiple ? 'flex' : 'none';
  navNext.style.display = hasMultiple ? 'flex' : 'none';
  navCounter.style.display = currentTryOnMatches.length ? 'block' : 'none';
  if(currentTryOnMatches.length){
    navCounter.textContent = `${currentTryOnIndex + 1} of ${currentTryOnMatches.length}`;
  }

  const mm = match ? parseFloat(match.eyeSize) : NaN;
  if(sizeReadout){
    if(!isNaN(mm) && mm > 0){
      sizeReadout.textContent = `${mm}mm frame width — a ${currentTryOnSize || 'matched'} fit for your face.`;
      sizeReadout.style.display = 'block';
    } else {
      sizeReadout.style.display = 'none';
    }
  }

  const cleanPhoto = getCleanPhotoDataUrl();
  if(!cleanPhoto || !lastLandmarks || !match){
    photo.style.display = 'none';
    glasses.style.display = 'none';
    controls.style.display = 'none';
    if(notWhiteHint) notWhiteHint.style.display = 'none';
    noPhotoHint.style.display = 'block';
    tryOnOverlay.classList.add('show');
    return;
  }

  noPhotoHint.style.display = 'none';

  const cleanGlasses = await processGlassesImage(match.image);
  if(!cleanGlasses){
    photo.style.display = 'none';
    glasses.style.display = 'none';
    controls.style.display = 'none';
    if(notWhiteHint){
      notWhiteHint.innerHTML = `This photo isn't a great fit for Try It On — <a href="${match.url}" target="_blank" rel="noopener">view the full product photos instead</a>.`;
      notWhiteHint.style.display = 'block';
    }
    tryOnOverlay.classList.add('show');
    return;
  }
  if(notWhiteHint) notWhiteHint.style.display = 'none';

  controls.style.display = 'flex';
  photo.src = cleanPhoto;
  photo.style.display = 'block';
  glasses.src = cleanGlasses;
  glasses.style.display = 'block';

  slot.__tryonState = computeAutoFit() || slot.__tryonDefault;
  applyTryonTransform(slot);

  tryOnOverlay.classList.add('show');
}
document.getElementById('tryOnClose').addEventListener('click', () => {
  tryOnOverlay.classList.remove('show');
});
tryOnOverlay.addEventListener('click', (e) => { if(e.target === tryOnOverlay) tryOnOverlay.classList.remove('show'); });

document.getElementById('tryonNavPrev').addEventListener('click', () => {
  if(!currentTryOnMatches.length) return;
  openTryOn((currentTryOnIndex - 1 + currentTryOnMatches.length) % currentTryOnMatches.length);
});
document.getElementById('tryonNavNext').addEventListener('click', () => {
  if(!currentTryOnMatches.length) return;
  openTryOn((currentTryOnIndex + 1) % currentTryOnMatches.length);
});

(function setupTryOnSwipe(){
  const stage = document.querySelector('#tryonSlotFront .tryon-stage');
  let touchStartX = null;
  stage.addEventListener('touchstart', e => {
    touchStartX = e.target.closest('.tryon-glasses') ? null : e.touches[0].clientX;
  }, { passive: true });
  stage.addEventListener('touchend', e => {
    if(touchStartX == null || !currentTryOnMatches.length) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    if(Math.abs(dx) < 40) return;
    const dir = dx < 0 ? 1 : -1;
    openTryOn((currentTryOnIndex + dir + currentTryOnMatches.length) % currentTryOnMatches.length);
  }, { passive: true });
})();

function setupTryOnSlot(slotId, defaultState){
  const slot = document.getElementById(slotId);
  const stage = slot.querySelector('.tryon-stage');
  const glasses = slot.querySelector('.tryon-glasses');

  slot.__tryonDefault = defaultState;
  slot.__tryonState = { ...defaultState };
  let dragging = false, startClientX = 0, startClientY = 0, startState = null;

  function pointerDown(e){
    dragging = true;
    const p = e.touches ? e.touches[0] : e;
    startClientX = p.clientX; startClientY = p.clientY;
    startState = { ...slot.__tryonState };
    e.preventDefault();
  }
  function pointerMove(e){
    if(!dragging) return;
    const p = e.touches ? e.touches[0] : e;
    const rect = stage.getBoundingClientRect();
    slot.__tryonState.xPct = startState.xPct + ((p.clientX - startClientX) / rect.width) * 100;
    slot.__tryonState.yPct = startState.yPct + ((p.clientY - startClientY) / rect.height) * 100;
    applyTryonTransform(slot);
  }
  function pointerUp(){ dragging = false; }

  glasses.addEventListener('mousedown', pointerDown);
  glasses.addEventListener('touchstart', pointerDown, { passive: false });
  window.addEventListener('mousemove', pointerMove);
  window.addEventListener('touchmove', pointerMove, { passive: false });
  window.addEventListener('mouseup', pointerUp);
  window.addEventListener('touchend', pointerUp);

  slot.querySelector('.tryon-scale-up').addEventListener('click', () => {
    slot.__tryonState.widthPct = Math.min(90, slot.__tryonState.widthPct + 3);
    applyTryonTransform(slot);
  });
  slot.querySelector('.tryon-scale-down').addEventListener('click', () => {
    slot.__tryonState.widthPct = Math.max(15, slot.__tryonState.widthPct - 3);
    applyTryonTransform(slot);
  });
  slot.querySelector('.tryon-rotate-left').addEventListener('click', () => {
    slot.__tryonState.angleDeg -= 3;
    applyTryonTransform(slot);
  });
  slot.querySelector('.tryon-rotate-right').addEventListener('click', () => {
    slot.__tryonState.angleDeg += 3;
    applyTryonTransform(slot);
  });
  slot.querySelector('.tryon-reset').addEventListener('click', () => {
    slot.__tryonState = { ...(computeAutoFit() || slot.__tryonDefault) };
    applyTryonTransform(slot);
  });
}

setupTryOnSlot('tryonSlotFront', { xPct: 50, yPct: 42, widthPct: 42, angleDeg: 0 });

/* ---------- Optical / Sunglasses switch: everything shown follows this choice ---------- */
function ensureCategoryToggle(gridEl){
  if(!document.getElementById('catToggleStyles')){
    const st = document.createElement('style');
    st.id = 'catToggleStyles';
    st.textContent = `
      .cat-toggle{display:flex;gap:0;margin:0 0 14px;border:1px solid var(--line,rgba(65,64,66,.14));background:var(--white,#fff)}
      .cat-toggle button{flex:1;padding:11px 8px;font-family:var(--sans,inherit);font-size:.72rem;letter-spacing:.12em;text-transform:uppercase;color:var(--dark,#414042);background:transparent;border:none;cursor:pointer;transition:background .15s,color .15s}
      .cat-toggle button.on{background:var(--dark,#414042);color:var(--white,#fff)}
      .cat-note{margin:0 0 12px;font-size:.78rem;color:var(--sage,#7e827c)}
    `;
    document.head.appendChild(st);
  }
  let tg = document.getElementById('catToggle');
  if(!tg){
    tg = document.createElement('div');
    tg.id = 'catToggle';
    tg.className = 'cat-toggle';
    tg.innerHTML = '<button type="button" data-cat="optical">Optical Frames</button><button type="button" data-cat="sunglasses">Sunglasses</button>';
    gridEl.parentNode.insertBefore(tg, gridEl);
    tg.addEventListener('click', (e) => {
      const b = e.target.closest('[data-cat]');
      if(!b) return;
      const fp = window.fitProfile;
      if(fp.category === b.dataset.cat) return;
      fp.category = b.dataset.cat;
      /* a size worked out for one category does not carry over to the other */
      fp.size = null; fp.sizeCategory = null; fp.sizeShape = null;
      updateFitProfilePanel();   /* also redraws the shop grid */
    });
  }
  tg.querySelectorAll('[data-cat]').forEach(b => b.classList.toggle('on', b.dataset.cat === window.fitProfile.category));
}

/* ---------- Shop Your Fit ---------- */
function updateShopYourFit(){
  const fp = window.fitProfile;
  const sfFaceShape = document.getElementById('sfFaceShape');
  const sfStyles = document.getElementById('sfStyles');
  const sfSize = document.getElementById('sfSize');
  const shopCtaBtn = document.getElementById('shopCtaBtn');
  const shopRecGrid = document.getElementById('shopRecGrid');

  if(fp.faceShape){ sfFaceShape.textContent = fp.faceShape; sfFaceShape.className = 'fp-value done'; }
  if(fp.styles && fp.styles.length){
    sfStyles.textContent = fp.styles.slice(0,4).map(k => FRAME_STYLES[k] ? FRAME_STYLES[k].name : k).join(' · ');
    sfStyles.className = 'fp-value done';
  }
  if(fp.size){ sfSize.textContent = fp.size; sfSize.className = 'fp-value done'; }

  ensureCategoryToggle(shopRecGrid);

  if(fp.faceShape && fp.styles.length){
    const topKeys = fp.styles.slice(0,3);
    shopRecGrid.innerHTML = '';
    topKeys.forEach(key => {
      const f = FRAME_STYLES[key];
      if(!f) return;
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'rec-card';
      card.dataset.style = key;
      card.innerHTML = `
        <div class="rec-thumb loading">${genericFrameIcon}</div>
        <div class="rec-body"><span>${f.name}</span>${arrowSvg}</div>
      `;
      shopRecGrid.appendChild(card);
      loadThumb(card.querySelector('.rec-thumb'), f, fp.category);
    });

    const primaryKey = topKeys[0];
    const primary = FRAME_STYLES[primaryKey];
    if(primary){
      if(fp.size){
        shopCtaBtn.classList.remove('disabled');
        shopCtaBtn.href = buildGenderUrl(primaryKey, fp.gender || 'Unisex');
        shopCtaBtn.innerHTML = 'Shop My Recommended Frames' + arrowSvg;
        const err = document.getElementById('shopCtaError');
        if(err) err.style.display = 'none';
      } else {
        shopCtaBtn.classList.add('disabled');
        shopCtaBtn.href = '#';
        shopCtaBtn.innerHTML = 'Check Your Size To Unlock';
      }
    }
  }
}

document.getElementById('shopCtaBtn').addEventListener('click', (e) => {
  if(e.currentTarget.classList.contains('disabled')){
    e.preventDefault();
    const err = document.getElementById('shopCtaError');
    if(err) err.style.display = 'block';
    document.getElementById('shopRecGrid').scrollIntoView({ behavior:'smooth', block:'center' });
  }
});

updateShopYourFit();
updateFitProfilePanel();
window.__updateFitProfilePanel = updateFitProfilePanel;